import { render, staticRenderFns } from "./RecaudacionPreciosComponent.vue?vue&type=template&id=5fb5488c"
import script from "./RecaudacionPreciosComponent.vue?vue&type=script&lang=js"
export * from "./RecaudacionPreciosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports